import React, {Component} from 'react';
import { Button, Modal, Label, Input } from 'reactstrap';
import Service from './services.js';
import _ from 'lodash';
import KeszletInfo from '../../../../commons/KeszletInfo';
import {CustomOption} from '../../../../commons/customOption';
import NumberFormatter from '../../../../commons/NumberFormatter';
import SlaveAvInput from '../../../../commons/SlaveAvInput';
import RFForm from '../../../../components/Form/RFForm.js';
import RFField from '../../../../components/Form/RFField.js';
import PriceInputComponent from '../../../../components/Form/PriceInputComponent.js';
import { calculatePrice } from '../../../../components/Form/PriceCalculator.js';
import moment from 'moment';
import SelectField from '../../../../components/Form/SelectField.js';
import TimeFormatter from '../../../../commons/TimeFormatter.js';
import CustomTooltip from '../../../../components/Tooltip/CustomTooltip.js';
import getTooltip from '../../KeszletTooltips.js';

const { removeSpacesFromString, removeRedundantZeros } = NumberFormatter;

class CikkSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {

      id: '',
      megnevezes: '',
      cikkszam: '',
      mennyisegiEgyseg: '',
      aktualisAfaErtek: '',
      cikk: undefined,

      hasMennyiseg: false,
      mennyiseg: '',
      nettoEgysegAr: '',
      nettoBeszAr: '',
      bruttoBeszAr: '',
      bruttoEgysegAr: '',
      pluszOsszeg: '',
      selejtezesOka: '',
      options: [],
      selejtezesOkaOptions: [],
      mennyisegDisabled: true,
      beviteliMezo: 'netto',
      onlyAktivCikk: false,
    };
  }

  componentDidMount() {
    const selejtezes = this.props.mozgasTipus && this.props.mozgasTipus.id === 'SELEJT';
    if (selejtezes) {
      this.loadSelejtezesOkaOptions();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.mozgasTipus != this.props.mozgasTipus) {
      this.setState({ onlyAktivCikk: this.props.mozgasTipus && (this.props.mozgasTipus.id === 'BEV' || this.props.mozgasTipus.id === 'INDL') });
    }
    if (!_.isEqual(prevProps.editobj, this.props.editobj) || prevProps.editmode != this.props.editmode || prevProps.isOpen != this.props.isOpen) {
      let cikkObj;
      const hasCikk = this.props.editobj && this.props.editobj.cikk;
      if (hasCikk) {
        cikkObj = {
          id:  this.props.editobj.cikkid,
          megnevezes:  this.props.editobj.cikk.megnevezes,
          cikkszam:  this.props.editobj.cikk.cikkszam,
          mennyisegiEgyseg:  this.props.editobj.cikk.mennyisegiEgyseg,
          aktualisAfaErtek: new String( this.props.editobj.cikk.aktualisAfaErtek),
        };
      }

      let editobj = this.prepareObject(this.props.editobj);

      let newState = {
        cikk: cikkObj,
        id: hasCikk ? editobj.cikkid : '',
        megnevezes: hasCikk ? editobj.cikk.megnevezes : '',
        cikkszam: hasCikk ? editobj.cikk.cikkszam : '',
        mennyisegiEgyseg: hasCikk ? editobj.cikk.mennyisegiEgyseg : '',
        aktualisAfaErtek: hasCikk ? editobj.cikk.aktualisAfaErtek : '',
        mennyiseg: editobj.mennyiseg,
        nettoEgysegAr: editobj.egysegarnetto,
        egysegAfa: removeRedundantZeros((editobj.egysegarbrutto - editobj.egysegarnetto).toFixed(6)),
        nettoBeszAr: editobj.beszerzesnetto,
        bruttoBeszAr: editobj.beszerzesbrutto,
        beszAfa: removeRedundantZeros((editobj.beszerzesbrutto - editobj.beszerzesnetto).toFixed(6)),
        bruttoEgysegAr: editobj.egysegarbrutto,
        pluszOsszeg: editobj.pluszosszeg,
        selejtezesOka: editobj.selejtezesOka ? {label: editobj.selejtezesOka.nev, value: editobj.selejtezesOka.id} : null,
        // TODO mindkettő kell?
        mennyisegDisabled: !this.props.editmode,
        hasMennyiseg: this.props.editmode,
      };

      this.setState({...newState});
    }
  }

  clearValues = () => {
    this.setState({
      cikk: undefined,
      cikkszam: '',
      megnevezes: '',
      mennyisegiEgyseg: '',
      mennyisegDisabled: true,
      mennyiseg: '',
      hasMennyiseg: false,
      aktualisAfaErtek: '',
      nettoEgysegAr: '',
      egysegAfa: '',
      bruttoEgysegAr: '',
      nettoBeszAr: '',
      beszAfa: '',
      bruttoBeszAr: ''
    });
  }

  loadSelejtezesOkaOptions = (input, callback) => {
    Service.listSelejtezesOka(null, (err, res) => {
      if (!err) {
        this.setState({
          selejtezesOkaOptions: res[0].map(k => ({value: k.id, label: k.nev}))
        });
      }
    });
  }

  prepareObject = (editobj) => {
    if (editobj) {
      Object.keys(editobj).forEach(field => {
        if (editobj[field] === 0) {
          editobj[field] = '0';
        }
      });
    } else {
      editobj = {};
    }
    return editobj; 
  }

  handleCikkChange = (newValue) => {
    let emptyObj = {
      cikk: undefined,
      cikkszam: '',
      megnevezes: '',
      mennyisegiEgyseg: '',
      aktualisAfaErtek: ''
    }
    let emptyPriceObj = {
        nettoEgysegAr: '',
        egysegAfa: '',
        bruttoEgysegAr: '',
        nettoBeszAr: '',
        beszAfa: '',
        bruttoBeszAr: '',
    };
    if (newValue === null) {
      this.setState({
        ...emptyObj,
        ...emptyPriceObj,
        mennyisegDisabled: true,
      });
    } else {
      if(this.props.keszletinfo) this.props.changeCikkId(newValue.id);

      const newState = {
        cikk: {
          megnevezes: newValue.megnevezes,
          cikkszam: newValue.cikkszam,
          id: newValue.id
        },
        id: newValue.id,
        megnevezes: newValue.megnevezes,
        cikkszam: newValue.cikkszam,
        mennyisegiEgyseg: newValue.mennyisegiEgyseg,
        aktualisAfaErtek: newValue.aktualisAfaErtek,
      };

      this.setState({
        ...newState,
        ...emptyPriceObj,
        mennyisegDisabled: false,
      });
    }
  }

  handleUpdateCikkInput = (text, callback) => {
    let newArray = [];
    if (text.length === 0) {
      callback(newArray);
    } else if (this.props.fromLeltar) {
      Service.queryCikk(text, JSON.parse('false'), false, TimeFormatter.formatDate(this.props.mozgasDatum), null, (err, res) => {
        if (!err) {
          res[0].forEach((res) => {
            if (!this.props.excludeCikkIds || !this.props.excludeCikkIds.includes(res.id)) newArray.push(res);
          });
          callback(newArray);
        }
      });
    } else {
      Service.queryCikk(text, JSON.parse('false'), false, TimeFormatter.formatDate(this.props.mozgasDatum), this.state.onlyAktivCikk, (err, res) => {
        if (!err) {
          res[0].forEach((res) => {
            newArray.push(res);
          });
          callback(newArray);
        }
      });
    }
  }

  formatMennyiseg = (value) => {
    let regExpString = "(?<=\\.\\d{2})\\d*";
    value = value.replace(new RegExp(regExpString, "g"), "");
    return value;
  }

  handleMennyiseg = (event, value) => {
    if (new RegExp(/(?<=\.)\d{3,}$/g).test(value)) {
      let regExpString = "(?<=\\.\\d{2})\\d*";
      value = value.replace(new RegExp(regExpString, "g"), "");
    }
    let priceArray;
    if (value && value > 0) {
      this.setState({ hasMennyiseg: true });
      if (value.slice('-1') !== '.' && this.state.nettoEgysegAr) {
        priceArray = calculatePrice(this.state.nettoEgysegAr, this.state.aktualisAfaErtek, value, this.props.penznem && this.props.penznem.tizedesjegy, true);
        this.handleArInput(priceArray);
      }
      _.debounce(() => {
        if (((this.props.mozgasTipus?.muvelet?.id === 'BEVETELEZES') || this.props.fromLeltar) && !this.state.nettoEgysegAr) {
          Service.getNettoEgysegByCikk(this.state.id, this.props.raktarId, (err, res) => {
            if (!err && res[0]) {
              let priceArray = calculatePrice(res[0], this.state.aktualisAfaErtek, value, this.props.penznem && this.props.penznem.tizedesjegy, true);
              this.handleArInput(priceArray);
            }
          });
        }
      }, 1000)?.();
    } else {
      this.setState({ hasMennyiseg: false });
    }
    this.setState({ mennyiseg: value });
  }

  handlePluszOsszeg = (event, value) => {
    this.setState({ pluszOsszeg: removeSpacesFromString(value) });
  }

  handleArInput = (priceArray) => {
    let [nettoEgysegAr, egysegAfa, bruttoEgysegAr, nettoBeszAr, beszAfa, bruttoBeszAr] = priceArray;
    this.setState({ nettoEgysegAr, egysegAfa, bruttoEgysegAr, nettoBeszAr, beszAfa, bruttoBeszAr });
  }

  handleCreateSelejtezesOka = (newSelejtezesOka) => {
    Service.addSelejtezesOka({ kod: newSelejtezesOka, nev: newSelejtezesOka }, (err, res) => {
      if (!err) {
        const selejtezesOkaOptions = this.state.selejtezesOkaOptions;
        const obj = { value: res[0].id, label: res[0].kod};
        this.setState({ 
          selejtezesOkaOptions: [...selejtezesOkaOptions, obj],
          selejtezesOka: obj
        });
      }
    });
  }

  deleteSelejtezesOka = (id) => {
    Service.deleteSelejtezesOka(id, (err, res) => {
      if (!err) {
        this.setState({ selejtezesOka: null });
        this.loadSelejtezesOkaOptions();
      }
    });  
  }

  checkCikkIds = (event, cikkObj) => {
    if (!this.state.bruttoEgysegAr && this.props.price) {
      this.props.globals.addError('Ár megadása kötelező!');
      return;
    }
    if (isNaN(Number(cikkObj.mennyiseg))) {
      this.props.globals.addError('Nem megfelelő mennyiség formátum!');
      return;
    }
    cikkObj.pluszOsszeg = removeSpacesFromString(cikkObj.pluszOsszeg);
    cikkObj.cikkid = this.state.id;
    cikkObj.egysegarnetto = Number(removeSpacesFromString(this.state.nettoEgysegAr));
    cikkObj.mennyiseg = Number(removeSpacesFromString(cikkObj.mennyiseg));
    cikkObj.egysegarbrutto = Number(removeSpacesFromString(this.state.bruttoEgysegAr));
    cikkObj.beszerzesnetto = this.state.nettoBeszAr;
    cikkObj.beszerzesbrutto = Number(removeSpacesFromString(this.state.bruttoBeszAr));
    cikkObj.beviteliMezo = this.state.beviteliMezo;
    cikkObj.selejtezesOka = this.state.selejtezesOka ? { id: this.state.selejtezesOka.value, nev: this.state.selejtezesOka.label, kod: this.state.selejtezesOka.label } : null;
    cikkObj.selejtezesOkaId = this.state.selejtezesOka ? this.state.selejtezesOka.value : null;
    cikkObj.id = this.props.editobj && this.props.editobj.id;
    
    let regExAr = RegExp(/^\d{0,12}(\.\d{0,6})?$/);
    let regExMenny = RegExp(/^\d{0,12}(\.\d{0,2})?$/);
    if (!regExAr.test(cikkObj.egysegarbrutto+"") || !regExAr.test(cikkObj.beszerzesbrutto+"") || !regExMenny.test(cikkObj.mennyiseg+"")) {
      this.props.globals.addError('Túl nagy érték lett megadva!');
      return;
    }

    if (cikkObj.beszerzesbrutto === ''){
      cikkObj.beszerzesbrutto = 0;
    }
    cikkObj.cikk = {
      id: this.state.id,
      megnevezes: cikkObj.megnevezes,
      cikkszam: cikkObj.cikkszam,
      mennyisegiEgyseg: cikkObj.mennyisegiEgyseg,
      aktualisAfaErtek: removeSpacesFromString(cikkObj.afa)
    };

    if (this.props.keszletinfo && this.props.raktar && !this.props.raktar.id) {
      this.props.globals.addWarning('Kötelező raktár választása a készletinfomáció során!');
      return;
    }

    if ((this.props.editobj && this.props.editobj.cikkid !== cikkObj.cikkid) && this.hasArrayElement(cikkObj.cikkid)) {
      this.props.globals.addWarning('Ez a cikk már hozzá van rendelve!');
      return;
    }

    if (this.props.editmode) {
      this.props.edit(event, cikkObj);
    } else {
      this.props.add(event, cikkObj);
    }
  }

  hasArrayElement = (id) => {
    let filteredArray = this.props.cikkek.filter(item => item.cikkid === id);
    return filteredArray.length > 0;
  }

  formatCreateLabel = input => (
    <span>
      <i>Hozzáadás: </i>
      {input}
    </span>
  );

  render() {
    const bevetelezes = this.props.mozgasTipus && this.props.mozgasTipus.id === 'BEV';
    const selejtezes = this.props.mozgasTipus && this.props.mozgasTipus.id === 'SELEJT';

    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} backdrop="static" size="md">
        <RFForm
          modal
          onSubmit={this.checkCikkIds}
          title="Cikk kiválasztása"
          footer={
            <>
              <Button color="primary" disabled={!this.state.hasMennyiseg}> {this.props.editmode ? 'Mentés' : 'Hozzáadás'}</Button>{' '}
              <Button type="button" color="secondary" onClick={this.props.toggle} >Mégsem</Button>
            </>
          }
        >
          <div className="row">
            <div className={this.props.keszletinfo ? "col-md-8" : "col-md-12" }>
              <SelectField
                variant='async'
                label='Név:'
                tooltip={this.state.onlyAktivCikk && <CustomTooltip text={getTooltip('onlyaktivcikk')} id="onlyaktivcikkTT" />}
                name="cikknev"
                id="cikknev"
                placeholder="Kezdj el gépelni a kereséshez..."
                noOptionsMessage={() => "Nincs keresési eredmény"}
                searchPromptText="Kezdj el gépelni a kereséshez..."
                loadingMessage={() => "Keresés..."}
                onChange={this.handleCikkChange}
                loadOptions={_.debounce(this.handleUpdateCikkInput, 1000)}
                value={this.state.cikk != {} ? this.state.cikk : undefined}
                isClearable
                isLoading={false}
                ignoreAccents={false}
                cache={false}
                autoload={false}
                getOptionValue={option => option.id}
                getOptionLabel={option => (option.megnevezes + " - " + option.cikkszam)} // - option.cikkszam
              />
            </div>
            { this.props.keszletinfo && this.state.id
            && (
            <div className="col-md-2">
                <KeszletInfo
                  buttonText="Készletinformáció"
                  handleListItemClick={this.props.handleListItemClick}
                  selectedSzabad={this.props.selectedSzabad}
                  onSave={this.props.onSave}
                  getData={this.props.getData}
                  formKeszletCikkId={this.state.id}
                  formKeszletRaktarId={this.props.raktar}
                  formKeszletCikkszam={this.state.cikkszam}
                  formKeszletCikknev={this.state.megnevezes}
                  raktarak={this.props.formKeszletInfoRaktarak}
                  loadingStatus={this.props.formKeszletLoadingStatus}
                  disabledButton={this.state.mennyisegDisabled}
                  />
            </div>
            )
            }
          </div>
          <div className='row'>
            <div className='col-md-6'>
              <RFField
                label="Cikkszám:"
                name="cikkszam"
                disabled
                value={this.state.cikkszam}
              />
            </div>
            <div className='col-md-6'>
              <RFField
                label="Megnevezés:"
                name="megnevezes"
                disabled
                value={this.state.megnevezes}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-8'>
              <SlaveAvInput
                id="mennyiseg"
                label="Mennyiség: *"
                disabled={this.state.mennyisegDisabled}
                onChange={this.handleMennyiseg}
                value={this.state.mennyiseg}
                format={this.formatMennyiseg}
                parse={this.formatMennyiseg}
                required
                szuroTipus={NumberFormatter.MENNYISEG}
              />
            </div>
            <div className='col-md-2'>
              <RFField
                label="Me.:"
                name="mennyisegiEgyseg"
                disabled
                value={this.state.mennyisegiEgyseg}
              />
            </div>
            <div className='col-md-2'>
              <RFField
                label="ÁFA%"
                name="afa"
                value={this.state.aktualisAfaErtek}
                disabled
              />
            </div>
          </div>
          <RFField
            style={{display: 'none'}}
            name="mennyiseg"
            ref="mennyiseg"
            value={this.state.mennyiseg}
          />
          {this.props.price && (
            <PriceInputComponent
              disabledArray={[!this.state.hasMennyiseg]}
              valueArray={[this.state.nettoEgysegAr, this.state.egysegAfa, this.state.bruttoEgysegAr, this.state.nettoBeszAr, this.state.beszAfa, this.state.bruttoBeszAr]}
              onChangeArray={this.handleArInput}
              afa={this.state.aktualisAfaErtek}
              mennyiseg={this.state.mennyiseg}
              tizedesjegy={this.props.penznem && this.props.penznem.tizedesjegy}
              tooltipText={this.props.fromLeltar && getTooltip('leltarar')}
            />
          )}
          {this.props.price && bevetelezes && (
            <React.Fragment>
              <div className="row">
                <div className="col-md-3">
                  Bekerülési értéket növelő összeg:
                </div>
                <div className="col-md-3">
                <SlaveAvInput
                  id="pluszosszeg"
                  label="Nettó:"
                  value={this.state.pluszOsszeg}
                  onChange={this.handlePluszOsszeg}
                  szuroTipus={NumberFormatter.OSSZEG}
                />
                <RFField style={{display: 'none'}} name="pluszosszeg" ref="pluszosszeg" value={this.state.pluszOsszeg} />
                </div>
              </div>
            </React.Fragment>
          )}
          {selejtezes && (
            <React.Fragment> 
              <div className="row">
                <div className="col-md-12" style={{paddingRight: '2px'}}>
                  <SelectField
                    variant='creatable'
                    label='Selejtezés oka:'
                    name="selejtezesoka"
                    id="selejtezesoka"
                    placeholder="Kezdj el gépelni..."
                    noOptionsMessage={() => 'Nincs keresési eredmény'}
                    formatCreateLabel={this.formatCreateLabel}
                    onChange={(v, t) => { this.setState({ selejtezesOka: v }); }}
                    onCreateOption={this.handleCreateSelejtezesOka}
                    onDeleteOption={this.deleteSelejtezesOka}
                    options={this.state.selejtezesOkaOptions}
                    getOptionLabel={option => option.label}
                    getOptionValue={option => option.value}
                    components={{ Option: CustomOption }}
                    value={this.state.selejtezesOka}
                    isClearable
                    defaultOptions
                  />
                </div>
              </div>
            </React.Fragment>
          )}
        </RFForm>
      </Modal>
    )
  }
}

export default CikkSelect;
